import './App.css';
import React, { useEffect } from 'react';
// import Navbar from './Components/navbar.js';
// import Content from './Components/content.js';
import PrivacyPolicy from './Pages/privacypolicy.js';
import TermsOfService from './Pages/termsofservice.js';
import Main from './Pages/main.js';
import Contact from './Pages/contact.js';
import Uninstall from './Pages/uninstall.js';
import Changelog from './Pages/changelog.js';
import Roadmap from './Pages/Roadmap.js';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import ScrollToTop from './Components/ScrollToTop';
import initGA, { trackPageView } from './utils/analytics';


// Component to track page views
const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    trackPageView(window.location.pathname + window.location.search);
  }, [location]);

  return null;
};

function App() {
  // Initialize Google Analytics when the app loads
  useEffect(() => {
    initGA();
  }, []);

  return (
    <Router>
      <PageViewTracker />
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route path="/termsofservice" element={<TermsOfService />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/uninstall" element={<Uninstall />} />
        <Route path="/changelog" element={<Changelog />} />
        <Route path="/roadmap" element={<Roadmap />} />
      </Routes>
    </Router>
  );
}

export default App;
